export default __webpack_public_path__ + "static/media/geral.a9427511.png";